// extracted by mini-css-extract-plugin
export default {"container":"C1-z","heading":"D1-z","links":"E1-z","copy":"F1-z","subCopy":"G1-z","linksLeft":"H1-z","linksCenter":"I1-z","linksRight":"J1-z","link":"K1-z","onlyLink":"L1-z"};